import React from "react";
import { FormHelperText } from "@mui/material";
// import Autocomplete from "@mui/material/Autocomplete";
import get from "lodash/get";
import mapValues from 'lodash/mapValues';
import * as combinatorV2 from '../../../../../../redux/combinatorV2.saga';
import * as fullReleaseRedux from "../../../../../../redux/fullRelease/reducer";
import {
  crudGetOne,
  CRUD_GET_ONE_SUCCESS,
} from '@/legacy/redux';
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import GoalMenu from "@/pages/models/release/GoalMenu";
import { graphlib } from "@dagrejs/dagre";


export const ContactEntityHelperText = ({ releaseHasActiveContact, releaseMetaContact }: { releaseHasActiveContact: boolean, releaseMetaContact: string | undefined }) => {
  const { t } = useTranslation();
  return (
    <FormHelperText component="div">
      {
        releaseHasActiveContact ?
          t('add_entity_modal.contact_entity_helper_text.other_entity_is_contact') + ' ' + releaseMetaContact
          :
          t('add_entity_modal.contact_entity_helper_text.mark_this_as_contact')
      }
    </FormHelperText>
  );
};

/**
 * both contact and contactId are typed like "undefined | null | string"\
 * and it's an issue with database
 */
export const getReleaseMetaContact = (release: any): undefined | string => {
  const raw = get(release, ['meta', 'contact'], undefined);

  return (raw === undefined || raw === null) ? undefined : String(raw);
};
export const getReleaseMetaContactId = (release: any): undefined | string => {
  const raw = get(release, ['meta', 'contactId'], undefined);

  return (raw === undefined || raw === null) ? undefined : String(raw);
};



export type ContactIdAutocompleteProps = {
  value: string;
  onChange: (v: string) => unknown;
  // options: Array<{ label: string; value: string; }>;
  graph: graphlib.Graph;
  entityName: string;
}
export const ContactIdAutocomplete: React.FC<ContactIdAutocompleteProps> = p => {
  const { value, onChange, graph, entityName } = p;
  const { t } = useTranslation();

  return (
    <>
      <GoalMenu
        graph={graph}
        goalId={value}
        onGoalIdChange={id => onChange(id)}
        allowEmpty
        entityName={entityName}
        showIdentifiers
        showHidden
        placeholder={t('add_entity_modal.contact_id_attribute')}
      />

      {/* <Autocomplete
        value={matched}
        options={options}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => <TextField {...params} label={t('add_entity_modal.contact_id_attribute')} variant="outlined" />}
        onChange={(_, value, reason) => {
          if(reason !== 'select-option' || !value) return;

          onChange(value.value);
        }}
      /> */}
    </>
  );
}

export const getAllAttributes = (release: any) => (
  get(release, ['rule_graph', 'nodes'], [])
    //.filter(it => !it.value.hidden && !it.value.identifier)
    .map(it => ({
      label: String(it.value.description),
      value: String(it.v),
      entity: String(it.value.entity),
      type: String(it.value.type),
      meta: Boolean(it.value.meta),
    }))
);

export const ContactIdHelperText = () => {
  const { t } = useTranslation();
  return (
    <FormHelperText component="div">
      {t('add_entity_modal.contact_id_helper_text')}
    </FormHelperText>
  )
};


export const useGetReleaseAndHideModalAction = (
  release: any,
  onClose?: () => void,
) => {
  const releaseId = release?.id;
  const dispatch = useDispatch();

  return React.useCallback(() => (
    combinatorV2.ActionCreator({
      bootstrap: crudGetOne('releases', releaseId),
      success: {
        type: CRUD_GET_ONE_SUCCESS,
        validate: (v: any) => v.meta.resource === 'releases',
        call: () => {
          dispatch(fullReleaseRedux.aCreators.requestToActualize());
          onClose?.();
        }
      }
    })
  ), [releaseId, dispatch, onClose]);
}

export const trimSpacesInValues = (values: any) => mapValues(values, v => (typeof v === 'string' ? v.trim() : v));
